import { useState } from "react"
import T from "../hooks/Language/T"
import TextField from "../UI/TextField"
import useTranslationSharie from "../hooks/Language/useTranslation"
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges"
import Icn from "../UI/SharieIcn/SharieIcn"
import { useApiService } from "../hooks/Api/useApiService"
import useError from "../hooks/Error/useError"
import { Paper, Stack, Typography, Divider, useTheme, Box } from "@mui/material"

const TransferCredit = () => {
  const [transfer, setTransfer] = useState({})
  const t = useTranslationSharie()
  const { postData } = useApiService()
  const { Error: AlertError, error, success } = useError()
  const theme = useTheme()

  const handleChange = (e, label) => {
    label === "amount"
      ? setTransfer((prev) => ({ ...prev, amount: e.target.value }))
      : setTransfer((prev) => ({ ...prev, to: e.target.value }))
  }

  const handleTransferCredit = () => {
    postData("users/transfercredit", {
      ...transfer,
      from: localStorage.getItem("user"),
    }).then((data) => {
      if (data?.message === "Successful") success("Credit was Successfully Transferred!")
      else error(data?.message)
    })
  }

  return (
    <T>
      <Paper
        elevation={4}
        sx={{
          p: 1.2,
          margin: "auto",
          borderRadius: "0.8rem",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TextField
            label={t("Transfer credit")}
            name='transfercredit'
            type='number'
            value={transfer.amount || ""}
            onChange={(event) => handleChange(event, "amount")}
            margin='dense'
          />

          <TextField
            label={t("Exact user name")}
            name='to'
            type='text'
            value={transfer.to || ""}
            onChange={(event) => handleChange(event, "to")}
            margin='dense'
          />

          <Box display='flex' justifyContent='flex-end'>
            <Icn
              tooltip={t("Transfer")}
              color='primary'
              icon={<PublishedWithChangesIcon color='secondary' />}
              onClick={handleTransferCredit}
            />
          </Box>

          <AlertError />
        </div>
      </Paper>
    </T>
  )
}
export default TransferCredit
